export const CODE_FORMATS = {
  /**
   * This format identifies a QR code with a child ID.
   */
  QR_CHILD_ID: "QR_CHILD_ID",
  /**
   * This format identifies a QR code with an order ID.
   */
  QR_ORDER_ID: "QR_ORDER_ID",
  /**
   * This format identifies a barcode product or a generic code.
   * Always check for this together with the GENERIC format since some codes might have the same patterns.
   */
  BARCODE_PRODUCT_OR_GENERIC: "BARCODE_PRODUCT_OR_GENERIC",
  /**
   * This format identifies a generic code.
   */
  GENERIC: "GENERIC"
} as const;

export type CodeFormat = keyof typeof CODE_FORMATS;
